__webpack_require__.p = "https://happy-hill-0c4c4691e.azurestaticapps.net/";